/*
 * @Author: xuejian3721
 * @Date: 2024-05-31 16:13:12
 * @LastEditors: xuejian3721
 * @LastEditTime: 2025-07-08 19:14:19
 */
import store from '@/store'
import router from '@/router'

// 设置订单样式
export function setOrderStyle(orderObj) {
  return store.state.mobile ? orderMobileStyle(orderObj) : orderPcStyle(orderObj)
}

// app端样式
function orderMobileStyle(orderObj) {
  let html = ''
  if (orderObj.itemNum > 1) {
    html += `<div>`
    orderObj.mainPicUrls.slice(0, 3).forEach(url => {
      html += `<img style="width: 48px;height: 48px;margin-right: 8px;background-size: cover;flex: 0 0 48px;" src="${url ||
        'https://s.yyjzt.com/kf-web/20240617/1718610240350455b.jpg'}"/>`
    })
    html += `</div>`
  } else {
    html += `<img style="width: 48px;height: 48px;margin-right: 8px;background-size: cover;flex: 0 0 48px;" src="${orderObj.mainPicUrl ||
      'https://s.yyjzt.com/kf-web/20240617/1718610240350455b.jpg'}"/>
        <div style="height: 48px;display: flex;flex-direction: column;flex: 1;overflow: hidden;margin: 0 12px 0 4px;justify-content: space-evenly;">
          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            <span style="font-size: 15px;color: #333333;">${orderObj.itemStoreName}</span>
          </div>
          <div style="font-size: 11px;color: #666666;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            <span>${orderObj.itemSpecs}</span> <span>${orderObj.itemManufacture}</span>
          </div>
        </div>`
  }
  const { platformId } = router.history.current.query
  console.log(platformId, 'platformId')
  let shouyingBtnHtml = ``
  if (store.state.platformGroups.group5.includes(platformId)) {
    shouyingBtnHtml = `<div class="btn btn-border" style="font-size: 13px;cursor:pointer;width: 104px;height: 27px;line-height: 27px;text-align: center;border: 1px solid #FA2E00;color: #FA2E00;border-radius: 27px" onclick="downloadSYDoc('${orderObj.storeName}','${orderObj.orderCode}', '${orderObj.storeId}')">下载首营资料</div>`
  }
  return `<div class="msg-card-order"
    style="min-width: 267px;display: flex;flex-direction: column;background: #ffffff;border-radius: 5px;padding:10px;">
    <div style="font-size: 14px;font-weight: 800;color: #111111;margin: 5px 0;">
      <span>您正在咨询的订单</span>
    </div>
    <div style="font-size: 12px;color: #111111;margin: 5px 0;">
      <span>订单编号：${orderObj.orderCode}</span>
    </div>
    <div style="display: flex;align-items: center;justify-content: space-between;margin: 5px 0;">
      ${html}
      <div style="height: 48px;display: flex;flex-direction: column;align-items: end;justify-content: space-evenly;">
        <div style="font-size: 16px;font-weight: 800;color: #111111;">
          <span><span style="font-size: 13px;">￥</span>${orderObj.originalPriceSum}</span>
        </div>
        <div style="font-size: 12px;color: #666666;">
          <span>共${orderObj.itemNum}件</span>
        </div>
      </div>
    </div>
    <div style="font-size: 12px;color: #999999;margin-top:12px; display: flex;justify-content: space-between;align-items: center;">
      <span >下单时间：${orderObj.orderTime}</span>
    </div>
     <div style="display: flex;justify-content: flex-end;margin-top: 12px">
      ${shouyingBtnHtml}
      <div style="width: 75px;height: 27px;font-size: 13px; margin-left: 10px ;color: #fff;background-color:#FA2E00 ; border: 1px solid #FA2E00 ;border-radius: 27px;cursor: pointer;display:flex;align-items: center;justify-content: center;"
        onclick="getOrderDetail('${orderObj.orderCode}')">查看订单</div>
      </div>
  </div>`
}

// pc端样式
function orderPcStyle(orderObj) {
  let html = ''
  if (orderObj.itemNum > 1) {
    html += `<div>`
    orderObj.mainPicUrls.slice(0, 3).forEach(url => {
      html += `<img style="width: 48px;height: 48px;margin-right: 8px;background-size: cover;flex: 0 0 48px;" src="${url ||
        'https://s.yyjzt.com/kf-web/20240617/1718610240350455b.jpg'}"/>`
    })
    html += `</div>`
  } else {
    html += `<img style="width: 48px;height: 48px;margin-right: 8px;background-size: cover;flex: 0 0 48px;" src="${orderObj.mainPicUrl ||
      'https://s.yyjzt.com/kf-web/20240617/1718610240350455b.jpg'}"/>
        <div style="display: flex;flex-direction: column;flex: 1;overflow: hidden;margin: 0 12px 0 4px;">
          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            <span style="font-size: 14px;color: #333333;">${orderObj.itemStoreName}</span>
          </div>
          <div style="font-size: 12px;color: #666666;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            <span>${orderObj.itemSpecs}</span> <span>${orderObj.itemManufacture}</span>
          </div>
        </div>`
  }
  const { platformId } = router.history.current.query
  console.log(platformId, 'platformId')
  let shouyingBtnHtml = ``
  if (store.state.platformGroups.group5.includes(platformId)) {
    shouyingBtnHtml = `<div style="display: flex; justify-content: flex-end"><div class="btn btn-border" style="font-size: 13px;cursor:pointer;width: 104px;height: 27px;line-height: 27px;text-align: center;border: 1px solid #FF0000;color: #FF0000;border-radius: 4px" onclick="downloadSYDoc('${orderObj.storeName}','${orderObj.orderCode}', '${orderObj.storeId}')">下载首营资料</div></div>`
  }
  return `<div class="msg-card-order"
    style="min-width: 267px;display: flex;flex-direction: column;background: #ffffff;border-radius: 8px;padding:8px;margin: 4px 0;">
    <div style="font-size: 14px;color: #333333;">
      <span>您正在咨询的订单</span>
    </div>
    <div style="font-size: 12px;color: #666666;">
      <span>订单编号：${orderObj.orderCode}</span>
    </div>
    <div style="display: flex;align-items: center;justify-content: space-between;margin: 5px 0;">
      ${html}
      <div style="display: flex;flex-direction: column;align-items: end;">
        <div style="font-size: 14px;color: #333333;">
          <span>￥${orderObj.originalPriceSum}</span>
        </div>
        <div style="font-size: 12px;color: #999999;">
          <span>共${orderObj.itemNum}件</span>
        </div>
      </div>
    </div>
    <div style="display: flex;flex-direction: column;justify-content: space-between;font-size: 12px;color: #999999;">
      <span >下单时间：${orderObj.orderTime}</span>
      <span >${orderObj.storeName}</span>
    </div>
    ${shouyingBtnHtml}
  </div>`
}
